module.exports = "<mat-progress-spinner  mode=\"indeterminate\">\n</mat-progress-spinner>"